import { render } from "./ClientesAdminView.vue?vue&type=template&id=b61d2290&ts=true"
import script from "./ClientesAdminView.vue?vue&type=script&lang=ts"
export * from "./ClientesAdminView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__